import * as React from 'react';
import { UserModel, UserDataModel } from 'franke-trough-dependencies';
import './../UserList/UserListItem.scss';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { filterUsersBySword, userIsInternal, userIsSalesRep } from '../utils';
import { filter as _filter } from 'lodash';
import classNames from 'classnames';
import cog from '../../../../assets/images/icons/cog.svg';
import close from '../../../../assets/images/icons/cross-rounded.svg';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import exclamation from '../../../../assets/images/icons/exclamation.svg';
import { Icon } from '../../Images';

 
export interface PostcodeListItemProps {
  user: UserModel;
  usersAdminList: GlobalPrivateState['users'];
  queryState: GlobalPrivateState['queryState'];
  language: GlobalPrivateState['localize']['language'];
  dispatch: any;
}

export interface PostcodeListItemState {
  user: UserModel;
  isInternal: boolean;
  isOpen: boolean;
  isDeleting: boolean;
  searchTerm: string;
  postcodes: string[];
  newPostcode: string;
}

export class PostcodeListItemManagePartial extends React.Component<PostcodeListItemProps, PostcodeListItemState> {
  constructor(props: PostcodeListItemProps) {
    super(props);
    const user = this.props.user;

    this.state = {
      user,
      isInternal: userIsInternal(user) || userIsSalesRep(user),
      isOpen: false,
      isDeleting: false,
      searchTerm: '',
      postcodes: user.userData && JSON.parse(JSON.stringify(user.userData.postcodes)) || [],
      newPostcode: ''
    };
  }

  componentDidUpdate(prevState: PostcodeListItemProps) {
    if (JSON.stringify(this.props.user) !== JSON.stringify(prevState.user)) {
      this.setState({
        user: this.props.user
      });
    }
  }

  public render() {
    const user = this.state.user;
    const userData = (user.userData as UserDataModel);
    const firstName = userData && userData.firstName;
    const lastName = userData && userData.lastName;
    const postcode = userData && userData.zip;
    const company = userData && userData.company;
    const addressAdditional = userData && userData.addressAdditional;
    const country = userData && userData.country.split('-')[1];
    const city = userData && userData.city;
    const postcodes = userData && userData.postcodes;
    const sortedPostcodesForDisplay = this.sortPostcodes(this.state.postcodes);

    return (
      <li key={user.id} className={classNames(
        'user-list-item user-list-item--manage user-list-item--postcode', {
          'user-list-item--open': this.state.isOpen,
          'user-list-item--clickable': this.state.isInternal
        })}> 
        <div className="user-list-item__header">
          <span className="user-list__fullname" title={firstName}>{!userData && <img className="img-fluid" src={exclamation} alt="User not registered" title="User not registered"/>}{firstName} {lastName}</span>
          <span className="user-list__postcode" title={postcode}>{postcode}</span>
          <span className="user-list__city" title={city}>{city}</span>
          <span className="user-list__country" title={country}>{country}</span>
          <span className="user-list__email" title={user.email}>{user.email}</span>
          <span className="user-list__postcodes">
            {sortedPostcodesForDisplay && sortedPostcodesForDisplay.length > 0 ? sortedPostcodesForDisplay.join(', ') : null}
          </span>
          <span className="user-list__assigned">
            {user.managees && user.managees.map((managee) => {
              return <span key={managee.id} title={managee.email}>{managee.userData ? `${managee.userData.firstName} ${managee.userData.lastName}` : 'MISSING'}<br/></span>
            })}
          </span>
          <span className="user-list__action">
            {this.state.isInternal && (
              <img 
                className="img-fluid" 
                src={this.state.isOpen ? close : cog}
                alt="edit"
                onClick={this.handleToggleOpen}
              />
            )}
          </span>
        </div>
        {this.state.isOpen && (
          <div className="user-list-item__body">
            <div className="user-list-item__postcodes-manage">
              <h2>Manage Postcode Areas</h2>
              <form 
                className="form form-postcodes-manage"
                onSubmit={(e) => {e.preventDefault();}}
              >
                {this.state.postcodes && this.state.postcodes.map((postcode: any, index: number) => {
                  return (
                    <div key={index} className="expanding-input">
                      <span>{postcode}</span>
                      <input type="text" value={postcode} onChange={(e) => this.handleChangePostcode(e, index)} />
                      <i onClick={(e) => this.handleRemovePostcode(e, index)}><Icon name="cross-roundel"/></i>
                    </div>
                  )
                })}
              </form>
            </div>
            <div className="user-list-item__postcodes-add">
              <h2>Add New Postcode Area</h2>
              <form className="form form-postcodes-add" onSubmit={this.handleAddNewPostcode}>
                <div className="expanding-input">
                  <span>{this.state.newPostcode || '0'}</span>
                  <input type="text" value={this.state.newPostcode} onChange={this.handleChangeNewPostcode} placeholder="000"/>
                </div>
                <button className="btn btn-secondary" type="submit" disabled={!this.state.newPostcode}><Icon name="plus-filled" /></button>
              </form>
            </div>
            <div className="user-list-item__postcodes-save">
              <h2>&nbsp;</h2>
              <button className="btn btn-secondary" onClick={this.handleSave}>Save</button>
            </div>
          </div>
        )}
      </li>
    );
  }

  handleToggleOpen = () => {
    this.setState({...this.state, isOpen: !this.state.isOpen})
  }

  handleRemovePostcode = (event: React.MouseEvent<HTMLElement, MouseEvent>, index: number) => {
    const editedPostcodes = this.state.postcodes;
    editedPostcodes.splice(index, 1);

    this.setState({
      ...this.state, 
      postcodes: editedPostcodes
    });
  }

  handleChangePostcode = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const editedPostcodes = this.state.postcodes;
    editedPostcodes[index] = event.target.value;

    this.setState({
      ...this.state, 
      postcodes: editedPostcodes
    });
  }

  handleChangeNewPostcode = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newPostcode = event.target.value;

    this.setState({
      ...this.state, 
      newPostcode: newPostcode
    });
  }

  handleAddNewPostcode = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); 

    if (!this.state.newPostcode) { return; }

    const editedPostcodes = this.state.postcodes;

    if (!editedPostcodes.includes(this.state.newPostcode)) {
      editedPostcodes.push(this.state.newPostcode);
    }

    this.setState({
      ...this.state, 
      newPostcode: '', 
      postcodes: editedPostcodes
    })
  }

  handleSave = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const user = this.state.user;

    if (!user.userData) { return; }

    const userData = user.userData;
    userData.postcodes = this.state.postcodes;

    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
      'userDataAdminned', {
        url: `/UserData/${userData.id}`,
        options: {
          method: 'PATCH',
          data: userData,
        },
      },
      true
    ));

    user.userData.postcodes = JSON.parse(JSON.stringify(userData.postcodes));
    this.setState({
      ...this.state, 
      user
    })
  }

  private sortPostcodes(postcodes?: string[]) {
    if (!postcodes || postcodes.length === 0) {
      return [];
    }

    return postcodes
      .slice()
      .map((p) => String(p).trim())
      .sort((a, b) => Number(a) - Number(b));
  }

  get userListForAdding() {
    const user = this.state.user;
    const sword = this.state.searchTerm;

    // if (!sword || sword.length <= 2) { return; } 

    const usersAdminList = this.props.usersAdminList.result;

    if (!usersAdminList) { return }

    const users = usersAdminList && usersAdminList.users;
    const matchingUsers = filterUsersBySword(users, sword) || [];
    // const externalMatchingUsers = _filter(matchingUsers, (u: UserModel) => !userIsInternal(u));
    const externalMatchingUsersWithoutUser = _filter(matchingUsers, (u: UserModel) => u.id !== user.id);

    return externalMatchingUsersWithoutUser.slice(0, 4);
  }

  get userListForRemoving() {
    return this.state.user.managees || [];
  }
}

export const PostcodeListItemManage = connect((state: GlobalPrivateState) => ({
  language: state.localize.language,
  usersAdminList: state.users,
  queryState: state.queryState
}))(PostcodeListItemManagePartial);

export default PostcodeListItemManage;
